import styles from './TeacherForm.module.scss';
import { HeaUnit, Unit } from '../../../types';
import Button from '@src/components/button/Button';
import { useMemo } from 'react';
import { isHomeEDApp } from '@constants';

type Props = {
  unit: any;
  openDetails:() => void;
};

function TeacherForm(props: Props) {
  const {
    unit,
    openDetails
  } = props;

  const isHEA = (unit as Unit)?.teacherBox === undefined

  const skills: string[] = useMemo(() => {
    try {
      const box = isHEA ? (unit as HeaUnit).parentBox : (unit as Unit).teacherBox
      return JSON.parse(box || '[]')
    } catch {
      return []
    }
  }, [isHEA, unit]);

  return (
    <div onClick={openDetails}>
      <div className={styles.subTitle}>Additional Materials</div>
      <div className={styles.card}>
        <div className={styles.image} >
          <Button label='VIEW' className={styles.startButton} onClick={openDetails}/>
        </div>
        <section className={styles.content}>
          <div className={styles.title}>{isHomeEDApp ? 'View Parent Preparation Materials:' :  `${unit?.teacherImage || 'View Unit Preparation Materials:'}`}</div>
          <div className={styles.description}>
            <ul className={styles.boxView}>
            {skills.map((skill, index) => {
              return (
                <li key={index} className={styles.questionBox}>
                  {skill}
                </li>
              );
            })}
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}

export default TeacherForm;
